<template>
    <div @click="closeModal" style="background-color: #00000080; display: flex; flex-direction: column; justify-content: center; align-items: center;">
        <div @click.stop="() => {}" style="width: 300px; background-color: #fff; border-radius: 20px; position: relative;">
            <template v-if="mission_type === MISSION_TYPE.INVITE_FRIENDS">
                <div style="position: absolute; top: -35px; left: 50%; transform: translateX(-50%);">
                    <img style="width: 161px;" :src="require('@/assets/img/invite_friends_popup.png')" alt="">
                </div>
                <div style="padding: 12px 20px;">
                    <div @click="checkPositionPopup(false)" style="font-weight: 700; font-size: 14px; line-height: 18px;">닫기</div>
                    <div style="text-align: center; margin-top: 131px;">
                        <div style="font-size: 20px; line-height: 32px; font-weight: 700;">🚀 초대 미션 성공!</div>
                        <div style="font-weight: 500; font-size: 14px; line-height: 18px; margin-top: 7px; color: #808080;">친구가 회원님을 통해 가입했어요!</div>
                        <div @click="checkPositionPopup(true)" style="margin-top: 16px; height: 50px; line-height: 50px; border-radius: 140px; margin-bottom: 4px; background-color: #315997; color: #fff; font-weight: 700; font-size: 15px;">포지션 찾기 PRO 무료로 하기</div>
                    </div>
                </div>
            </template>
            <template v-else-if="mission_type === MISSION_TYPE.UPLOAD_TRAINING_VIDEO">
                <div style="position: absolute; top: -62px; left: 50%; transform: translateX(-50%);">
                    <img style="width: 163px;" :src="require('@/assets/img/upload_training_popup.png')" alt="">
                </div>
                <div style="position: absolute; width: 100%; z-index: 1; ">
                    <img style="width: 100%;" :src="require('@/assets/img/popup_gif.gif')" alt="">
                </div>
                <div style="text-align: center; margin-top: 167px; padding: 0 16px; position: relative; z-index: 2;">
                    <div style="font-size: 20px; line-height: 32px; font-weight: 700;">훈련 영상을 업로드했어요</div>
                    <div style="font-weight: 500; font-size: 14px; line-height: 18px; margin-top: 5px; color: #808080;">감독님들에게 훈련 피드백을 직접 받아보세요</div>
                    <div style="display: flex; justify-content: space-between; margin-top: 16px; margin-bottom: 21px;">
                        <div @click="closeModal" style="background-color: #ECF0F3;" class="upload_common_btn">확인</div>
                        <div @click="goToFeedback" style="background-color: var(--color-main);" class="upload_common_btn">피드백 받기</div>
                    </div>
                </div>
            </template>
            <template v-else-if="mission_type === MISSION_TYPE.REPLY">
                <div style="position: absolute; top: -64px; left: 50%; transform: translateX(-50%);">
                    <img style="width: 123px;" :src="require('@/assets/img/reply_popup.png')" alt="">
                </div>
                <div style="position: absolute; width: 100%; z-index: 1; ">
                    <img style="width: 100%;" :src="require('@/assets/img/popup_gif.gif')" alt="">
                </div>
                <div style="text-align: center; padding: 0 16px; margin-top: 144px; position: relative; z-index: 2;">
                    <div v-if="!isCompleteReplyMission">
                        <div style="font-size: 20px; font-weight: 700; line-height: 28px;">댓글 미션 성공!<br/>5포인트를 받았어요</div>
                        <div style="font-size: 14px; font-weight: 500; color: #606060; margin-top: 6px;">오늘 <span style="font-size: 16px; color: var(--color-main); font-weight: 700;">{{ 5 - replyMissionCount }}번 더 포인트를 받을 기회</span>가 있어요.</div>
                    </div>
                    <div v-else>
                        <div style="font-size: 20px; font-weight: 700; line-height: 28px;">댓글 미션 성공!</div>
                        <div style="font-weight: 500; font-size: 14px; line-height: 21px; margin-top: 7px; color: #808080;">오늘도 더 이상 댓글로 포인트를 받을 수 없어요.<br/>내일도 댓글 달고 포인트를 모아보세요!</div>
                    </div>
                    <div style="display: flex; justify-content: space-between; margin-top: 16px; margin-bottom: 21px;">
                        <div @click="closeModal" style="background-color: #ECF0F3;" class="upload_common_btn">확인</div>
                        <div @click="goToGround" style="background-color: var(--color-main);" class="upload_common_btn">댓글 남기기</div>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { MISSION_TYPE } from '@/Constants'
import ResponseCode from '@/ResponseCode'

export default {
    name: 'CompleteMissonPopup',
    props: {
        mission_type: {
            type: String,
            default: ''
        },
        isCompleteReplyMission: {
            type: Boolean,
            default: false
        },
        replyMissionCount: {
            type: [Number, String],
            default: 0
        },
        position_pro_history_idx: {
            type: [String, Number],
            default: -1
        }
    },
    created() {
        console.log(this.position_pro_history_idx)
    },
    data() {
        return {
            MISSION_TYPE: MISSION_TYPE,
        }
    },
    methods: {
        closeModal() {
            if (this.mission_type === MISSION_TYPE.INVITE_FRIENDS) {
                this.checkPositionPopup()
                return
            }
            this.$GlobalStore.closeLastModal()
        },
        goToFeedback() {
            this.$GlobalStore.closeModalAll()
            this.$router.push({ path: '/view/soccer_learn?time=' + new Date().getTime() + '&is_from_popup_video=true' });
        },
        goToGround() {
            this.$GlobalStore.closeModalAll()
            this.$router.push({ path: '/view/soccer_learn?time=' + new Date().getTime() + '&is_from_popup=true' });
        },
        async checkPositionPopup(isGoToPosition) {
            const formData = new FormData()
            formData.append('position_pro_history_idx', this.position_pro_history_idx)
            const res = await this.$Axios.post('/api/position/invitation/popup/checked', formData)
            
            if (res.data.code === ResponseCode.SUCCESS) {
                this.$GlobalStore.closeLastModal()
                if (isGoToPosition) {
                    this.$GlobalStore.addModal('FindPositionProStart')
                }
            } else {
                alert('실패')
            }
        }
    },
}
</script>

<style scoped>
    .upload_common_btn {
        width: 126px;
        height: 41px;
        line-height: 41px;
        text-align: center;
        border-radius: 40px;
        font-size: 14px; 
        font-weight: 500;
    }
</style>